export default __webpack_public_path__ + "static/media/Bottom Navigation.b17e248a.svg";